import { Container, Row, Col } from "react-bootstrap";

import navIcon1 from "../assets/img/nav-icon1.svg";
import navIcon2 from "../assets/img/github.svg";
import navIcon3 from "../assets/img/nav-icon3.svg";
import mylogo from "../assets/img/icon.png";

const scrollToSelector = (selector) => {
  const element = document.querySelector(selector);

  if (element) {
    element.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  }
};

export const Footer = () => {
  return (
    <footer className="footer">
      <Container>
        <Row className="align-items-center">

          {/* Logo */}
          <Col
            md={4}
            className="text-center text-md-start"
          >
            <img
              src={mylogo}
              alt="Harsh Agria"
              className="x"
            />
          </Col>

          {/* Footer Content */}
          <Col
            md={8}
            className="text-center text-md-end"
          >

            {/* Social Icons */}
            <div className="social-iconf">
              <a
                href="https://www.linkedin.com/in/iamharshagria/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
              >
                <img
                  src={navIcon1}
                  alt="LinkedIn"
                />
              </a>

              <a
                href="https://github.com/HarshAgria/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="GitHub"
              >
                <img
                  src={navIcon2}
                  alt="GitHub"
                />
              </a>

              <a
                href="https://www.instagram.com/harshagria"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
              >
                <img
                  src={navIcon3}
                  alt="Instagram"
                />
              </a>
            </div>

            {/* Footer Navigation */}
            <nav
              className="footer-navigation"
              aria-label="Footer navigation"
            >
              <a
                href="#home"
                className="footerbar"
                onClick={() => scrollToSelector("#home")}
              >
                Home
              </a>

              <a
                href="#skills"
                className="footerbar"
                onClick={() => scrollToSelector("#skills")}
              >
                Skills
              </a>

              <a
                href="#experience"
                className="footerbar"
                onClick={() => scrollToSelector("#experience")}
              >
                Experience
              </a>

              <a
                href="#achievements"
                className="footerbar"
                onClick={() => scrollToSelector("#achievements")}
              >
                Achievements
              </a>

              <a
                href="#education"
                className="footerbar"
                onClick={() => scrollToSelector("#education")}
              >
                Education
              </a>

              <a
                href="#project"
                className="footerbar"
                onClick={() => scrollToSelector("#project")}
              >
                Projects
              </a>

              <a
                href="#connect"
                className="footerbar"
                onClick={() => scrollToSelector("#connect")}
              >
                Connect
              </a>
            </nav>

            {/* Copyright */}
            <p className="copyright">
              © {new Date().getFullYear()} Harsh Agria. All Rights Reserved.
            </p>

          </Col>
        </Row>
      </Container>
    </footer>
  );
};
